function validate(key, value, t, data) {
    const regexInteger = /^[-+]?\d+$/;
    const regex = /^[a-zA-Z0-9_]+$/;
    const floatRegex = /^[-+]?\d+(\.\d+)?$/;
    const checkTypeData = parseInt(data.data_type)
    switch (key) {
        case 'code':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'validate.code.require'
                }
            }
            if (!regex.test(value)) {
                return {
                    value: true,
                    helperText: 'validate.code.special-regex'
                }
            }
            if (value?.length > 50) {
                return {
                    value: true,
                    helperText: 'validate.code.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'name':
            if (value?.length === 0) {
                return {
                    value: true,
                    helperText: 'validate.name.require'
                }
            }
            if (value?.length > 100) {
                return {
                    value: true,
                    helperText: 'validate.name.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'description':
            if (value?.length > 250) {
                return {
                    value: true,
                    helperText: 'validate.descRole.max-length'
                }
            }
            return {
                value: false,
                helperText: ''
            }
        case 'default_value':
            //boolean
            if (checkTypeData === 0) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.require'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.max-length'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            //string
            if (checkTypeData === 1) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.require'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.max-length'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            //integer
            if (checkTypeData === 2) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.require'
                    }
                }

                if (!regexInteger.test(value)) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.integer'
                    }
                }

                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.max-length'
                    }
                }

                if (parseInt(value, 10) < -2147483648 || parseInt(value, 10) > 2147483647) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.valid-value'
                    }
                }

                return {
                    value: false,
                    helperText: ''
                }
            }
            //float
            if (checkTypeData === 3) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.require'
                    }
                }
                if (!floatRegex.test(value)) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.float'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.max-length'
                    }
                }

                if (parseFloat(value) < -3.4028235E38 || parseFloat(value) > 3.4028235E38) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.valid-value'
                    }
                }

                return {
                    value: false,
                    helperText: ''
                }
            }
            //utc
            if (checkTypeData === 4) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.defaultValue.require'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            break
        case 'value':
            //boolean
            if (checkTypeData === 0) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.value.require'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.value.max-length'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            //string
            if (checkTypeData === 1) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.value.require'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.value.max-length'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            //integer
            if (checkTypeData === 2) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.value.require'
                    }
                }

                if (!regexInteger.test(value)) {
                    return {
                        value: true,
                        helperText: 'validate.value.integer'
                    }
                }

                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.value.max-length'
                    }
                }

                if (parseInt(value, 10) < -2147483648 || parseInt(value, 10) > 2147483647) {
                    return {
                        value: true,
                        helperText: 'validate.value.valid-value'
                    }
                }

                return {
                    value: false,
                    helperText: ''
                }
            }
            //float
            if (checkTypeData === 3) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.value.require'
                    }
                }
                if (!floatRegex.test(value)) {
                    return {
                        value: true,
                        helperText: 'validate.value.float'
                    }
                }
                if (value?.length > 500) {
                    return {
                        value: true,
                        helperText: 'validate.value.max-length'
                    }
                }

                if (parseFloat(value) < -3.4028235E38 || parseFloat(value) > 3.4028235E38) {
                    return {
                        value: true,
                        helperText: 'validate.value.valid-value'
                    }
                }

                return {
                    value: false,
                    helperText: ''
                }
            }
            //utc
            if (checkTypeData === 4) {
                if (value?.length === 0) {
                    return {
                        value: true,
                        helperText: 'validate.value.require'
                    }
                }
                return {
                    value: false,
                    helperText: ''
                }
            }
            break
        default:
            return;
    }
}
export const handleValidateInput = (data, t) => {
    const error = {
        code: { value: false, helperText: '' },
        name: { value: false, helperText: '' },
        description: { value: false, helperText: '' },
        is_active: { value: false, helperText: '' },
        data_type: { value: false, helperText: '' },
        default_value: { value: false, helperText: '' },
        value: { value: false, helperText: '' },
        requires: { value: false, helperText: '' },
        groups: { value: false, helperText: '' }
    }
    Object.keys(error).forEach(key => error[key] = validate(key, data[key], t, data))
    return error
}